// Auxilary : Generic container that propagates all parent's props 

var aux = function aux(props) {
  return props.children;
};

export default aux;


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-quiz/es/components/Quizz/hoc/_Aux.js
// module id = 62
// module chunks = 0